/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
} from './Contact';

/**
 * 
 * @export
 * @interface DeliveryAdditionalInfo
 */
export interface DeliveryAdditionalInfo {
    /**
     * 
     * @type {Contact}
     * @memberof DeliveryAdditionalInfo
     */
    contact?: Contact;
    /**
     * Total quantity of all products in the basket
     * @type {string}
     * @memberof DeliveryAdditionalInfo
     */
    numberOfItemsBasket?: string;
    /**
     * Specifies whether the delivery and the billing addresses are the same
     * @type {string}
     * @memberof DeliveryAdditionalInfo
     */
    addressDeliveryBillingMatchIndicator?: string;
    /**
     * The date on which the last delivery address used by the merchant's account was reported in the transaction
     * @type {string}
     * @memberof DeliveryAdditionalInfo
     */
    deliveryAddressCreationDate?: string;
    /**
     * Estimated Delivery Delay (in days) by the Merchant
     * @type {string}
     * @memberof DeliveryAdditionalInfo
     */
    estimatedDeliveryDelay?: string;
    /**
     * Delivery Method (Postal Office or Amazon box and so on)
     * @type {string}
     * @memberof DeliveryAdditionalInfo
     */
    deliveryMode?: string;
}

/**
 * Check if a given object implements the DeliveryAdditionalInfo interface.
 */
export function instanceOfDeliveryAdditionalInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeliveryAdditionalInfoFromJSON(json: any): DeliveryAdditionalInfo {
    return DeliveryAdditionalInfoFromJSONTyped(json, false);
}

export function DeliveryAdditionalInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryAdditionalInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contact': !exists(json, 'contact') ? undefined : ContactFromJSON(json['contact']),
        'numberOfItemsBasket': !exists(json, 'numberOfItemsBasket') ? undefined : json['numberOfItemsBasket'],
        'addressDeliveryBillingMatchIndicator': !exists(json, 'addressDeliveryBillingMatchIndicator') ? undefined : json['addressDeliveryBillingMatchIndicator'],
        'deliveryAddressCreationDate': !exists(json, 'deliveryAddressCreationDate') ? undefined : json['deliveryAddressCreationDate'],
        'estimatedDeliveryDelay': !exists(json, 'estimatedDeliveryDelay') ? undefined : json['estimatedDeliveryDelay'],
        'deliveryMode': !exists(json, 'deliveryMode') ? undefined : json['deliveryMode'],
    };
}

export function DeliveryAdditionalInfoToJSON(value?: DeliveryAdditionalInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contact': ContactToJSON(value.contact),
        'numberOfItemsBasket': value.numberOfItemsBasket,
        'addressDeliveryBillingMatchIndicator': value.addressDeliveryBillingMatchIndicator,
        'deliveryAddressCreationDate': value.deliveryAddressCreationDate,
        'estimatedDeliveryDelay': value.estimatedDeliveryDelay,
        'deliveryMode': value.deliveryMode,
    };
}

